
import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AdsClickOutlined } from '@mui/icons-material';
import InfoIcon from '@mui/icons-material/Info';
import { Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function HowToUseDialog() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
        <Button
        onClick={handleClickOpen}
      sx={{
        borderRadius: '16px',
        boxShadow: 'none',
        boxSizing:'border-box',
        border: '2px solid #eee',
        height:'60px',
        display:'flex',
        alignItems:'center',
        minWidth: {xs:10, sm: 200},
        marginTop:'0px',
        padding:'16px',
        marginLeft:'auto',
        marginRight:'8px'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent:'center', boxSizing:'border-box', 
    }}>
        <Box
          sx={{
            backgroundColor: 'rgba(0, 115, 230, 0.2)',
            borderRadius: '50%',
            padding:'4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <InfoIcon color="primary" sx={{ fontSize: 24 }} />
        </Box>

        {/* Text area */}
        <Box>
          <Typography variant="subtitle1" sx={{ ml:1, display: {xs:'none', sm:'block'}, fontWeight: '500', textTransform:'capitalize' }}>
            How to use Search
          </Typography>
        </Box>
      </Box>
    </Button>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          How To Use Search
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <Typography variant="body1" gutterBottom>
            Follow these steps to get the most out of the Search feature:
          </Typography>

  <Typography variant="body1">
    <ul style={{paddingLeft:'25px'}}>
      <li style={{marginBottom:'10px'}}>Start typing the name of a medicine in the search box. You can type in a brand name or a generic name.</li>
      <li style={{marginBottom:'10px'}}>You'll see a dropdown with autocomplete suggestions.</li>
      <li style={{marginBottom:'10px'}}>
        Matching results will appear highlighted:
        <ul style={{paddingLeft:'25px', marginBottom:'10px'}}>
          <li>
            Brand name matches appear in <span style={{ color: '#0bac0d', fontWeight:'bold' }}>Green</span>.
          </li>
          <li>
            Generic name matches appear in <span style={{ color: '#3898ec', fontWeight:'bold' }}>Blue</span>.
          </li>
          <li>
            Non-exact or similar matches will also appear in the dropdown.
          </li>
        </ul>
      </li>
      <li style={{marginBottom:'10px'}}>Select the medicine you want from the dropdown to see all available brands.</li>
      <li style={{marginBottom:'10px'}}>
        Click the <AdsClickOutlined style={{marginRight:'2px', marginLeft:'2px', marginBottom:'-5px', background:'#ededed', border:'1px solid #ededed', borderRadius:'50%'}}/> icon to view side effects, or the <ExpandMoreIcon style={{marginRight:'2px', marginLeft:'2px', marginBottom:'-5px', background:'#ededed', border:'1px solid #ededed', borderRadius:'50%'}} /> icon to see more details about the medicine.
      </li>
    </ul>
  </Typography>
        </DialogContent>

        
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Done
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}
